import { select, dispatch } from "@wordpress/data";
import { compose } from '@wordpress/compose'
import { InnerBlocks } from "@wordpress/block-editor";
import TitleSubtitleParagraph
  from "~buildable/components/title-subtitle-paragraph";
import withStylesPreview from "~buildable/higher-order/with-styles-previews";
import withInspectorTabs from "~buildable/higher-order/with-inspector-tabs";
import {INSPECTOR_TABS} from "~buildable/utils/constants";
import ActiveInnerBlockControls
  from "~buildable/components/active-inner-block-controls";

const edit = props => {
  console.log("testimonial-slider edit", props);
  const { clientId, setAttributes } = props;

  const {
    title,
    subtitle,
    paragraph
  } = props.attributes;

  const ALLOWED_BLOCKS = ["buildable/testimonial"];
  const TEMPLATE = [ALLOWED_BLOCKS]

  select("core/editor").getBlocksByClientId(clientId)[0].innerBlocks
    .forEach((block, index) => {
      dispatch("core/editor").updateBlockAttributes(block.clientId, { index })
    });

  return (
    <div className="testimonial-slider">
      <div className="tsp-container">
        <TitleSubtitleParagraph
          title={ title }
          subtitle={ subtitle }
          paragraph={ paragraph }
          setAttributes={ setAttributes }
        />
      </div>

      <div className="testimonials-container">
        <div className="testimonials">
          <ActiveInnerBlockControls
            { ... props }
            content={(
              <InnerBlocks
                allowedBlocks={ ALLOWED_BLOCKS }
                template={ TEMPLATE }
              />
            )}
          />
        </div>
      </div>
    </div>
  );
}

export default compose(
  withStylesPreview(),
  withInspectorTabs(INSPECTOR_TABS),
)(edit);
